module.exports = __webpack_public_path__ + "static/media/IOT.13e1d1b0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Svg/IOT.svg
// module id = 1370
// module chunks = 0